var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
import * as React from "react";
import { observe, observable } from "mobx";
import { tickerDefaultConfig } from "./TickerDefaultConfig";
import { CurrencyHelpers } from "../../../../helpers";
import { observer } from "mobx-react";
import { store } from "../../../../data";
let TickerDiv = class TickerDiv extends React.Component {
    constructor(props) {
        super(props);
        this.padLeftPx = 10;
        this.fillTextLength = 0;
        this.currencySymbol = store.getCurrencySymbol(this.props.jackpot.currencyId);
        this.config = Object.assign(Object.assign({}, tickerDefaultConfig), (props.tickerConfig || {}));
        observe(this.props.jackpot, "tickerValue", change => this.tickerUpdateListenerFn.bind(this)(change.newValue), true);
    }
    tickerUpdateListenerFn(newValue) {
        if (!newValue) {
            return;
        }
        this.fillText = CurrencyHelpers.moneyFormat("{1} {0}", newValue, this.currencySymbol);
        let currentFillText = this.fillText.length;
        if (currentFillText === this.fillTextLength) {
            return;
        }
        this.fillTextLength = currentFillText;
        this.divWidth = this.fillTextLength * this.config.pxPerSymbol + this.padLeftPx;
    }
    render() {
        return React.createElement("div", { style: { width: this.divWidth }, className: "rj-jackpot__item-ticker-value" }, this.fillText);
    }
};
__decorate([
    observable,
    __metadata("design:type", String)
], TickerDiv.prototype, "fillText", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], TickerDiv.prototype, "divWidth", void 0);
TickerDiv = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], TickerDiv);
export { TickerDiv };
//# sourceMappingURL=TickerDiv.js.map